/* eslint-disable @typescript-eslint/ban-types */

import semver from 'semver';

export const INVALID_VERSION_MESSAGE = 'not a valid semver range';

export function genId(dto: any = {}): number {
  if (dto.id) {
    return dto.id;
  }

  return Date.now() + genId.counter;
}

genId.counter = 0;

export function validateVersion(version: string): boolean {
  return semver.validRange(version) !== null;
}

type PropertyNames<T> = {
  [K in keyof T]?: T[K] extends (args: any[]) => any ? never : K;
}[keyof T];

export type Properties<T> = Pick<T, NonNullable<PropertyNames<T>>>;

export type Dto<T> = Partial<Properties<T>>;
export type StringDto<T> = Partial<Record<keyof Dto<T>, string>>;
export type DictionaryLike<T> = Partial<Record<keyof T, string>>;

export type DtoOmit<T, K extends keyof any> = Omit<Dto<T>, K>;

export type EntityProps<T, Om = ''> = Exclude<
  NonNullable<PropertyNames<T>>,
  'allErrorsAsStrings' | 'errors' | 'isEmpty' | 'isValid' | Om
>;

export type RequireAllProps<T> = {
  [K in keyof Required<T>]: T[K];
};
